import React, { useState } from 'react';
import PaymentMethodForm from './PaymentMethodForm';
import './PaymentFailedNotice.css';
import InlineAlert from '../common/InlineAlert';
import { getUserFacingError } from '../../lib/userFacingErrors';

export default function PaymentFailedNotice({ open, onResolved }) {
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  if (!open) return null;

  const handlePaymentSuccess = async () => {
    setUpdating(true);
    setError(null);
    try {
      await onResolved?.();
    } catch (e) {
      console.error('[PaymentFailedNotice] refreshBilling failed:', e);
    }
    setUpdating(false);
  };

  return (
    <div className="payment-failed-overlay">
      <div className="payment-failed-modal">
        <div className="payment-failed-icon">!</div>
        <h2>Payment Failed</h2>
        <p>
          Your most recent payment was declined. Please update your payment method to continue
          using the app.
        </p>
        {updating ? (
          <div className="payment-failed-updating">Updating payment method...</div>
        ) : (
          <PaymentMethodForm
            onSuccess={handlePaymentSuccess}
            onError={(e) => setError(getUserFacingError(e, 'payment-method'))}
            submitLabel="Update Payment Method"
          />
        )}
        {error && <InlineAlert title={error.title} message={error.message} />}
      </div>
    </div>
  );
}
